import { BrowserSessionApiClient } from './browserSessionApiClient';

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/+$/, '');

export type PmAgentGridColumn = {
  key: string;
  label: string;
  type: 'string' | 'number' | 'currency' | 'date' | 'boolean';
};

export type PmAgentToolResult = {
  tool: string;
  resultType: 'rows' | 'aggregate' | 'analysis';
  columns: PmAgentGridColumn[];
  rows: Array<Record<string, unknown>>;
  rowCount: number;
  facts: Record<string, unknown>;
  datasets?: Array<{
    name: string;
    result: Omit<PmAgentToolResult, 'datasets'>;
  }>;
};

export type PmAgentRunResult = {
  answer: string;
  summary: string;
  intent: string;
  selectedTool: string;
  arguments: Record<string, unknown>;
  result: PmAgentToolResult;
  debug: {
    intent: Record<string, unknown>;
    selectedTool: string;
    arguments: Record<string, unknown>;
    futureActionTools: string[];
    notes: string[];
  };
};

function unwrapData<T>(value: any): T {
  return (value?.data ?? value) as T;
}

class PmAgentService {
  private readonly browserClient = new BrowserSessionApiClient(API_BASE_URL);

  async query(input: { message: string }): Promise<PmAgentRunResult> {
    const response = await this.browserClient.request('/api/v1/pm-agent/query', {
      method: 'POST',
      body: {
        message: input.message,
      },
    });
    return unwrapData<PmAgentRunResult>(response);
  }
}

export const pmAgentService = new PmAgentService();
